import { render, staticRenderFns } from "./youxizonglan.vue?vue&type=template&id=40b9c70e&scoped=true"
import script from "./youxizonglan.vue?vue&type=script&lang=js"
export * from "./youxizonglan.vue?vue&type=script&lang=js"
import style0 from "./youxizonglan.vue?vue&type=style&index=0&id=40b9c70e&prod&lang=scss&scoped=true"
import style1 from "./youxizonglan.vue?vue&type=style&index=1&id=40b9c70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9c70e",
  null
  
)

export default component.exports